module.exports = __webpack_public_path__ + "static/media/tisgo.30e8e912.jpg";